class AutoAsnwerCallbackService {
  listOfCallsInCallbackToAnswer = new Map();

  addCallInList(queueid, info) {
    this.listOfCallsInCallbackToAnswer.set(parseInt(queueid), info);
  }
  removeCallOfList(queueid) {
    this.listOfCallsInCallbackToAnswer.delete(parseInt(queueid));
  }
  isThisCallAlreadyInTheList(queueid) {
    return this.listOfCallsInCallbackToAnswer.has(parseInt(queueid));
  }
  resetList() {
    this.listOfCallsInCallbackToAnswer.clear();
  }
}

export const autoAsnwerCallbackServiceSingleton =
  new AutoAsnwerCallbackService();
